var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.logo)?_c('nuxt-link',{class:_vm.$style.logo,attrs:{"to":"index"}},[_c('img',{attrs:{"src":_vm.logo}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }